import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'homey-page-subtitle-layout',
  imports: [
    NgClass
  ],
  templateUrl: './page-subtitle-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageSubtitleLayoutComponent {
  readonly centered = input<boolean>(false);
  readonly size = input<'medium' | 'large'>('medium');
}
